import { isEmpty } from "lodash";

export const validarTelefone = (valor: string) => {
    if (isEmpty(valor))
        return '.';

    return `, ou entre em contato conosco pelo telefone ${valor}.`;
}